module.exports = __webpack_public_path__ + "img/messagebase.cb38e5b7.gif";